import React from 'react';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import it from 'date-fns/locale/it';
import { view } from 'react-easy-state';
import Store from '../store/store';
import PrestSceltaTipoImp from './PrestSceltaTipoImp';
import PrestImpInput from './PrestImpInput';
import "react-datepicker/dist/react-datepicker.css";
import Fade from 'react-reveal/Fade';
import { withTranslation } from 'react-i18next';

const FADE_DURATION = 300;

class PrestImpegnativa extends React.Component {

  onUpdatePrestazione = (e) => {
    const { idx } = this.props;
    const { updatePrestazione } = Store;
    const val = e.target.value;
    const key = e.target.name;

    updatePrestazione(idx, key, val);
  }

  onUpdateData = (val) => {
    const { updatePrestazione } = Store;
    const { idx } = this.props;

    updatePrestazione(idx, 'impData', val);
  }

  onClickContinua = () => {
    const { idx } = this.props;
    const { updatePrestazione } = Store;
    
    updatePrestazione(idx, 'isComplete', true);
  }

  render() {
    const { idx, t } = this.props;
    const { 
      prestazioni,
      showPrestImpegnativa,
      showInputDatiImpegnativa,
      showPrestContinuaBtn
    } = Store;

    const prestazione = prestazioni[idx];

    const impClasses = classNames({
      'kfpr-cont': true,
      'kfpr-cont-imp': true,
      'kfpr-inactive': !showPrestImpegnativa(idx),
      'kfpr-hidden': !showPrestImpegnativa(idx)
    });

    const contClasses = classNames({
      'kfpr-content': true,
      'kfpr-content-imp': true
    });

    return (
      <Fade bottom duration={FADE_DURATION}>
        <div className={impClasses}>                            
          <div className="kfpr-row kfpr-row-head">
            <span>{t("impegnativa medica")}</span>
            {
              !prestazione.get('isComplete') && <strong>{t("Inserisci i Dati")}</strong>
            }
     
            {
              prestazione.get('isComplete') && 
              <div>
                <div role="button" className="kfpr-sel" href="#">
                    <span>{prestazione.get('impY')}</span>
                    <span>{prestazione.get('impTipo') === 'IC' ? ' - ' : ''}</span>
                    <span>{prestazione.get('impTipo') === 'IC' ? prestazione.get('impS') : ''}</span>
                </div>
                <div className="kfpr-row kfpr-row-small">
                    <span>{t("Data impegnativa")}</span>
                    <strong>{
                      new Date(prestazione.get('impData')).toLocaleDateString('it-IT', { year: 'numeric', month: 'numeric', day: 'numeric' })}</strong>
                </div>
              </div>
            }
          </div>        
          {
          !prestazione.get('isComplete') &&
          <div className={contClasses}>
            <div className="kfpr-input-data">
              <div className="kfpr-input">
                <label>
                  <span className="kf-orange-txt">*</span>
                    {t("Data impegnativa")}&nbsp;
                  <span className="kfpr-smalltxt">{t("GG/MM/AAAA")}</span>
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={prestazione.get('impData')}
                  maxDate={Date.now()}
                  onChange={this.onUpdateData}
                  onKeyDown={(e) => e.preventDefault()}
                  withPortal
                  locale={it}
                />      
              </div>
            </div>   
            <div className="kfpr-row kfpr-row-txt kfpr-row-txt-big">
            <p>{t("Sei in possesso di una")} <em>{t("Impegnativa cartacea")}</em> {t("o di una")} <em>{t("Ricetta elettronica")}</em>?</p>
              <PrestSceltaTipoImp prestazione={prestazione} onClick={this.onUpdatePrestazione} />
            </div>                 
          </div>
          }
          {
            showInputDatiImpegnativa(idx) && !prestazione.get('isComplete') &&
            <PrestImpInput prestazione={prestazione} 
              onUpdate={this.onUpdatePrestazione} 
              onClickContinua={this.onClickContinua} 
              showContinuaBtn={showPrestContinuaBtn(idx)} />
          }
          
        </div>
      </Fade>
    )
  }
}

export default withTranslation()(view(PrestImpegnativa));